//https://cryptokitties.fandom.com/wiki/Color_palette_%26_HEX_codes

// These are the colours from CCFGB website: dark blue, red, light blue, gray

const colors = ['#004079', '#e50043', '#009cde', '#f2f2f2']

export default colors
